import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';
import { useEffect, useState } from 'react';
import { useAppDispatch, useSelector } from '../../rahtab-redux';
import { addInvoice, invoiceSelector, setHasNextPage } from '../../rahtab-redux/slices/invoicesSlice';

function useInvoiceList(rowId: number) {
  const dispatch = useAppDispatch();
  const [invoiceIds, setInvoiceIds] = useState<Set<string> | undefined>();
  const { hasNextPage } = useSelector((state) => state.invoices);
  const invoices = useSelector(invoiceSelector(Array.from(invoiceIds?.values() || [])));
  const [refetch, { data, loading, called, fetchMore }] = useFetchCallType<FactorInfo[]>('GetPaymentHistory', {
    params: `RowID=${rowId}&Count=10`,
    skip: !hasNextPage,
  });
  useEffect(() => {
    let temp = new Set(invoiceIds);
    if (!loading) {
      if (data?.length === 0) dispatch(setHasNextPage(false));
      data?.forEach((item) => {
        temp.add(item.FactorCode);
        dispatch(addInvoice(item));
      });
      setInvoiceIds(temp);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  return {
    data: invoices,
    loading: !invoiceIds,
    called,
    fetchMore,
    hasNextPage,
    refetch,
  };
}

export default useInvoiceList;

export interface FactorInfo {
  FactorCode: string;
  TotalDept: string; //مبلغ صورت حساب
  TotalPrice: string; //مجموع قیمت
  FromDate: string; // از تاریخ
  ToDate: string; // تا تاریخ
  PayFlag: boolean; // فلگ پرداخت
  PayDate: string; // تاریخ پرداخت
  PayTag: string; //تگ پرداخت موفق
  HasOfficialFactorRequest: boolean; //درخواست صدور فاکتور رسمی دارد
  OfficialFactorId: string; //کد فاکتور رسمی
  OfficialFactorStatus: string; // وضعیت فاکتور رسمی : 0 صادر نشده 1 صادر شده

  DeptList: DeptInfo[]; //لیست بدهی ها
}
interface DeptInfo {
  DeptCode: string;
  TemplateName: string; // نام کالا
  Amount: string; //مقدار
  MeasureName: string; // واحد
  Price: string; //قیمت به ریال
  Status: string; // وضعیت
}
